import { render, staticRenderFns } from "./CardSoundEffect.vue?vue&type=template&id=ddb0fe5c&scoped=true&"
import script from "./CardSoundEffect.vue?vue&type=script&lang=js&"
export * from "./CardSoundEffect.vue?vue&type=script&lang=js&"
import style0 from "./CardSoundEffect.vue?vue&type=style&index=0&id=ddb0fe5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb0fe5c",
  null
  
)

export default component.exports